import { useEffect, useRef, useState } from "react";
import { WasteStationSignatureResult } from "api/transportSedel.api";
import { Uppdrag, UppdragStatus } from "types/uppdrag.type";
import userStore, { getUserRole } from "store/user.store";
import { Role } from "types/enums";

// Öppna "Slutför uppdrag"-modalen när alla uppgifter blir klara medan sidan
// är öppen. Gäller endast operatörer. Kräver en övergång false -> true så att
// modalen inte visas för uppdrag som redan var klara när sidan laddades.
export const useCompleteUppdragOnUppgifterDone = (uppdrag?: Uppdrag) => {
  const prevAllCompletedRef = useRef(uppdrag?.areAllUppgiftsCompleted);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [results, setResults] = useState<WasteStationSignatureResult[]>([]);
  const role = userStore(getUserRole);

  useEffect(() => {
    if (
      role === Role.Operator &&
      prevAllCompletedRef.current === false &&
      uppdrag?.areAllUppgiftsCompleted &&
      (uppdrag.uppgiftCount ?? 0) > 0 &&
      uppdrag.status !== UppdragStatus.Completed
    ) {
      setResults([
        {
          isReadyToBeCompleted: true,
          facility: uppdrag.facility,
          uppdragId: uppdrag.id,
          uppdragUuid: uppdrag.uuid,
          estimatedWorkingHours:
            uppdrag.timeReportData?.estimatedWorkingHours ?? undefined,
          estimatedDrivingHours:
            uppdrag.timeReportData?.estimatedDrivingHours ?? undefined,
        },
      ]);
      setIsModalOpen(true);
    }

    prevAllCompletedRef.current = uppdrag?.areAllUppgiftsCompleted;
  }, [uppdrag, role]);

  return {
    isModalOpen,
    results,
    closeModal: () => setIsModalOpen(false),
  };
};
